enum MediaContextEnum {
  OVERVIEW_INNER_HOME = 'overview_inner_home',
  SELF_DISCOVERY = 'self_discovery',
  THERAPY_APPROACH = 'therapy_approach',
  STATIC_PAGE = 'static_page',
}

export default MediaContextEnum;
